export const GET_BALANCES = 'GET_BALANCES';
export const GET_BALANCES_SUCCESS = 'GET_BALANCES_SUCCESS';
export const GET_BALANCES_ERROR = 'GET_BALANCES_ERROR';
export const ADD_BALANCES = 'ADD_BALANCES';
export const ADD_BALANCES_SUCCESS = 'ADD_BALANCES_SUCCESS';
export const ADD_BALANCES_ERROR = 'ADD_BALANCES_ERROR';

export const getBalances = () => ({
  type: GET_BALANCES,
});

export const addBalances = (payload) => ({
  type: ADD_BALANCES,
  payload,
});
